import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from 'shared';
import { NgModule } from '@angular/core';
import * as homePage from './pages/home';
import { HomeRoutingModule } from './home-routing.module';
import { HomeService } from './services/home.service';
import { CoreComponentsModule, CoreModule } from '@app/core';
import { SectionFooterComponent } from './pages/home/components/sections/section-footer/section-footer.component';
import { AcercaComponent } from './pages/acerca/acerca.component';
import { InformacionComunidadComponent } from './pages/informacion-comunidad/informacion-comunidad.component';


@NgModule({
  imports: [
    HomeRoutingModule,
    SharedModule,
    HttpClientModule,
    CoreModule,
    CoreComponentsModule
  ],
  declarations: [
    homePage.HomeComponent,
    homePage.SectionHomeBannerComponent,
    homePage.SectionHomeBuscadorComponent,
    homePage.SectionHomeInfoPrincipalComponent,
    homePage.SectionHomeLinksDestacadosComponent,
    SectionFooterComponent,
    AcercaComponent,
    InformacionComunidadComponent
  ],
  entryComponents: [
  ],
  providers: [
    HomeService
  ]
})
export class HomeModule { }
